/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Findings_Demo_SourceInputs */



/**
* | output |
* | --- |
* | "Partner invite" |
*
* @param {Products_Findings_Demo_SourceInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_findings_demo_source = /** @type {((inputs?: Products_Findings_Demo_SourceInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Findings_Demo_SourceInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приглашение партнёра")
	return /** @type {LocalizedString} */ ("Partner invite")
});